export const SLEEP_JOURNAL_GET_JOURNALS_BEGIN = 'SLEEP_JOURNAL_GET_JOURNALS_BEGIN';
export const SLEEP_JOURNAL_GET_JOURNALS_SUCCESS = 'SLEEP_JOURNAL_GET_JOURNALS_SUCCESS';
export const SLEEP_JOURNAL_GET_JOURNALS_FAILURE = 'SLEEP_JOURNAL_GET_JOURNALS_FAILURE';
export const SLEEP_JOURNAL_GET_JOURNALS_DISMISS_ERROR = 'SLEEP_JOURNAL_GET_JOURNALS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/sleep-journal/redux/constants.js